import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 12 2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 2\" id=\"minus\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.334 1.166a.5.5 0 01-.5.5H1.167a.5.5 0 010-1h9.667a.5.5 0 01.5.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol